/* global $:false FB:false */

export default class FacebookShare {
  static init () {
    const $el = $('#facebook-share')
    if (!($el.length > 0)) { return }
    this.fetchFacebookAPI()
  }

  static share () {
    FB.ui({
      method: 'share',
      href: window.location.href
    }, response => false)
  }

  static fetchFacebookAPI () {
    $.ajaxSetup({ cache: true })
    $.getScript('//connect.facebook.net/en_US/sdk.js', () => FB.init({
      appId: '1486576158203921',
      version: 'v9.0'
    }))
  }
}
